import React, { Fragment, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import "./styles.css";

export interface KPIRow {
    renderRow: () => JSX.Element;
}

interface KPITableProps {
    tableRows: KPIRow[];
}

const KPI_TABLE_HEADER = ["Related SOP", "Current Progress", "Key Performance Indicator (KPI)", "Process point", "Action"];

const KPITable = (props: KPITableProps) => {
    const [widthOfTableInPercentageOfParent, setWidthOfTableInPercentageOfParent] = useState(100);

    useEffect(() => {
        const updateWidthOfTableBasedOnSidebar = () => {
            const sidebar = document.querySelector(".sidebar");
            if (sidebar) {
                const sidebarWidth = sidebar.clientWidth;
                const newWidth = (1 - sidebarWidth / window.innerWidth) * 100;
                setWidthOfTableInPercentageOfParent(newWidth - 1);
            }
        };

        const sidebar = document.querySelector(".sidebar");
        if (sidebar) {
            const resizeObserver = new ResizeObserver((entries) => {
                for (let entry of entries) {
                    updateWidthOfTableBasedOnSidebar();
                }
            });
            resizeObserver.observe(sidebar);

            return () => resizeObserver.disconnect();
        }
    }, []);

    const renderTableHeader = () => {
        return (
            <thead>
                <tr>
                    <th></th>
                    {KPI_TABLE_HEADER.map((header, index) => (
                        <th key={index} style={{ position: header === "Action" ? "sticky" : "relative", right: header === "Action" ? 0 : "auto" }}>
                            {header}
                        </th>
                    ))}
                </tr>
            </thead>
        );
    };

    const renderTableRows = () => {
        return props.tableRows.map((row, index) => <Fragment key={index}>{row.renderRow()}</Fragment>);
    };

    return (
        <div style={{ width: `${widthOfTableInPercentageOfParent}%` }}>
            <Table className="kpi-table" striped bordered hover responsive>
                {renderTableHeader()}
                <tbody>{renderTableRows()}</tbody>
            </Table>
        </div>
    );
};

export default KPITable;
